import React from 'react';
import { Button, Col, FormGroup, FormLabel, Modal, ModalProps, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Form, Formik } from 'formik';
import { object, string } from 'yup';

import { FormikControl } from '@components/Base';
import { yupFile } from '@utils/yup';

import { DocumentCreatePayload } from './action';

export type DocumentFormValues = Pick<DocumentCreatePayload, 'name' | 'document'>;

type FormFormProps = Pick<ModalProps, 'onHide'> & { title: string };

const FormForm = ({ onHide, title }: FormFormProps) => {
  const { t } = useTranslation();

  return (
    <Form>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormGroup as={Row} className="mb-3" controlId="name">
          <FormLabel column sm={4}>
            {t('user.name')}*
          </FormLabel>
          <Col sm>
            <FormikControl name="name" required />
          </Col>
        </FormGroup>

        <FormGroup as={Row} className="mb-3" controlId="document">
          <FormLabel column sm={4}>
            {t('common:document')}*
          </FormLabel>
          <Col sm>
            <FormikControl name="document" type="file" required />
          </Col>
        </FormGroup>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t('confirmModal.cancel')}
        </Button>
        <Button type="submit" variant="primary">
          {t('common:save')}
        </Button>
      </Modal.Footer>
    </Form>
  );
}

type Props = ModalProps & {
  onSubmit: (values: DocumentFormValues) => void;
  title: string;
}

const DocumentFormModal = ({ onSubmit, title, ...props }: Props) => {
  const { t } = useTranslation();

  const validationSchema = object({
    name: string().required(t('validation:required')),
    document: yupFile().required(t('validation:required')),
  });

  const initialValues: DocumentFormValues = {
    name: '',
    document: undefined,
  };

  return (
    <Modal {...props}>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        <FormForm onHide={props.onHide} title={title} />
      </Formik>
    </Modal>
  )
};

export { DocumentFormModal };
